export var QueryHistoryStatus;
(function (QueryHistoryStatus) {
    QueryHistoryStatus["PENDING"] = "pending";
    QueryHistoryStatus["READY"] = "ready";
    QueryHistoryStatus["ERROR"] = "error";
    QueryHistoryStatus["CANCELLED"] = "cancelled";
})(QueryHistoryStatus || (QueryHistoryStatus = {}));
//# sourceMappingURL=queryHistory.js.map